import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const TimesIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon {...props} ref={ref} viewBox="0 0 8 8">
        <path
          d="M0.229799 0.237631C-0.0765994 0.554472 -0.0765996 1.06817 0.229799 1.38501L2.88918 4.13504L0.49121 6.61324C0.18472 6.92999 0.18472 7.44354 0.49121 7.76028C0.797701 8.07703 1.29462 8.07703 1.60111 7.76028L3.99875 5.28242L6.39696 7.76237C6.70336 8.07921 7.20013 8.07921 7.50653 7.76237C7.81293 7.44553 7.81293 6.93183 7.50653 6.61499L5.10865 4.13538L7.77013 1.38484C8.07662 1.06809 8.07662 0.554549 7.77013 0.237803C7.46364 -0.0789426 6.96672 -0.0789426 6.66023 0.237803L3.99908 2.988L1.33936 0.237631C1.03297 -0.0792102 0.536197 -0.0792102 0.229799 0.237631Z"
          fill="#F66969"
        />
      </SvgIcon>
    );
  })
);
